'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_6cfce947 = {"container":"Checkbox_module_container__152a3c21","checked":"Checkbox_module_checked__152a3c21","control":"Checkbox_module_control__152a3c21","disabled":"Checkbox_module_disabled__152a3c21","read-only":"Checkbox_module_readOnly__152a3c21","input":"Checkbox_module_input__152a3c21","label":"Checkbox_module_label__152a3c21","icon":"Checkbox_module_icon__152a3c21"};
require("../../../assets/cjs/components/Checkbox/src/Checkbox~Dk3Quy33.css");

exports.default = modules_6cfce947;
//# sourceMappingURL=Checkbox.module.less.js.map
